<template>
  <svg :width="size" :height="size" viewBox="0 0 20 20">
    <path
      d="m9.991 8.691-5.017 4.945a.94.94 0 0 1-1.319 0 .923.923 0 0 1-.01-1.305l5.02-4.947L9.991 6.07l1.332 1.308 5.03 4.963a.925.925 0 0 1 .01 1.307.944.944 0 0 1-1.331.01L9.992 8.69z"
      fill="#737380"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '20',
    },
  },
}
</script>
